<template>
  <div class="wizard-body small-12 medium-9 columns">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.CALL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.CALL.DESC')"
    />
    <div class="small-12 medium-8 columns">
      <label>
        {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.TYPE') }}
        <select v-model="provider">
          <option value="twilio">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.TWILIO') }}
          </option>
          <option value="sid">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.SIP') }}
          </option>
        </select>
      </label>
    </div>
    <twilio v-if="provider === 'twilio'" type="call"></twilio>
    <SIP  v-else/>
    <!-- <bandwidth-sms v-else /> -->
  </div>
</template>

<script>
import PageHeader from '../../SettingsSubPageHeader';
import BandwidthSms from './BandwidthSms.vue';
import Twilio from './Twilio';
import SIP from './SIP.vue';


export default {
  components: {
    PageHeader,
    Twilio,
    BandwidthSms,
    SIP,
  },
  data() {
    return {
      provider: 'twilio',
    };
  },
};
</script>
